module.exports = __webpack_public_path__ + "static/media/lorelai-4.44338c14.wav";